import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { useSelector, useDispatch } from "react-redux";
import LoadingSpinner from "../../../components/client/LoadingSpinner";
import { handleApi } from "../../../utils/authentication";
import { UPDATE_USER_DATA } from "../../../redux/features/user/userSlice";
import "./programs.css";
import ProgramViewEdit from "./components/ProgramViewEdit";
import ProgramCard from "./components/ProgramCard";
import { programs } from "../client-tour/programs";
import useClientTour from "../../../hooks/useClientTour";


const Progrmas = () => {
  const [activeTab, setActiveTab] = useState("all_programs");
  const [show, setShow] = useState(false);
  const [programList, setProgramList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const user = useSelector((state) => state?.user);
  const [programId, setProgramId] = useState();
  const dispatch = useDispatch();

  useClientTour({
    enabled: !user?.has_seen_tour && user?.is_client,
    steps: programs,
    tourKey: "programs_page",
    nextRoute: "/client/campaigns",
    skipRoute: "/client/programs",
  });

  //get program list

  const getProgramList = async () => {
    try {
      setIsLoading(true);
      let method = "POST";
      let headers = {};
      let formData = new FormData();
      formData.append("client_id", user?.client_id);
      formData.append("role_id", user?.role_id);
      formData.append("user_id", user?.user_id);

      let result = await handleApi(`program_list`, method, headers, formData);
      if (result?.success) {
        setProgramList(
          result?.data?.programs_list.sort((a, b) => {
            const nameA = a.program_name.toUpperCase();
            const nameB = b.program_name.toUpperCase();

            if (nameA < nameB) {
              return -1;
            }
            if (nameA > nameB) {
              return 1;
            }
            return 0;
          })
        );
        dispatch(
          UPDATE_USER_DATA({
            count_of_programs: result?.data?.programs_list?.length,
          })
        );
      } else {
        toast.error(
          result?.error?.error_message
            ? result?.error?.error_message
            : "Failed to fetch program list",
          {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          }
        );
      }
    } catch (e) {
      console.log(e);
      toast.error(e?.message ? e?.message : "Failed to fetch program list", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getProgramList();
  }, [user?.client_id, show]);


  return (
    <div className="">
      {isLoading ? (
        <LoadingSpinner />
      ) : (
        <>
          <div className="row campaign_header_tab d-flex align-items-center mb-4">
            <div className="col-lg-10 col-md-12 p-0 ">
              <div className="d-flex gap_lg ">
                <span href="" onClick={() => setActiveTab("all_programs")}>
                  <p
                    className={`mb-0 ${activeTab === "all_programs" &&
                      "campaign_header_tab_active"
                      }`}
                  >
                    All Programs (
                    {programList?.length ? programList?.length : 0})
                  </p>

                </span>
                {/* <span href="" onClick={() => setActiveTab("mine_programs")}>
                  <p
                    className={`mb-0 ${
                      activeTab === "mine_programs" &&
                      "campaign_header_tab_active"
                    }`}
                  >
                    Mine (0)
                  </p>
                  
                </span>

                <span
                  href=""
                  onClick={() => setActiveTab("completed_programs")}
                >
                  <p
                    className={`mb-0 ${
                      activeTab === "completed_programs" &&
                      "campaign_header_tab_active"
                    }`}
                  >
                    Completed (0)
                  </p>
                  
                </span> */}

                {/* <span href="" onClick={() => setActiveTab("archived_programs")}>
                  <p
                    className={`mb-0 ${
                      activeTab === "archived_programs" &&
                      "campaign_header_tab_active"
                    }`}
                  >
                    Archived (0)
                  </p>
                
                </span> */}
              </div>
            </div>
            <div className="col-lg-2 col-md-12 d-flex justify-content-lg-end p-0">
              {(user?.role_id === 2 || user?.role_id === 1) && (
                <button
                  onClick={() => {
                    setShow(true);
                    setProgramId(null);
                  }}
                  className="btn btn-md  rounded-pill  btn-primary px-3 create_program_btn"
                >
                  Create Program
                </button>
              )}
            </div>
          </div>

          <div className="program_card program_list">
            <div className="d-flex justify-content-between align-items-center  program_card_heading ">
              <p className="mb-0">PROGRAMS LIST</p>
            </div>
            <div className="program_card_body">
              {programList &&
                programList?.length > 0 &&
                programList.map((program) => {
                  return (
                    <ProgramCard
                      key={program?.program_id}
                      program={program}
                      setProgramId={setProgramId}
                      setShow={setShow}
                    />
                  );
                })}
            </div>

            {!isLoading && programList && programList.length === 0 && (
              <div style={{ position: "absolute", left: "37%", top: "50%" }}>
                <div className=" w-full " role="status">
                  <h5>No Progrmas To Display</h5>
                </div>
              </div>
            )}
          </div>
        </>
      )}

      <ProgramViewEdit
        program_id={programId}
        setProgramId={setProgramId}
        show={show}
        setShow={setShow}
      />
    </div>
  );
};

export default Progrmas;
